import { motion } from "framer-motion";
import styles from "./style.module.scss";
const ourApproachList = [
    {
        title: "Collaborative Strategy Development",
        description:
            "We team up with your law firm to formulate a pricing strategy that aligns with your performance goals and fulfills your specific needs.",
    },
    {
        title: "Custom Campaign Creation",
        description:
            "By conducting in-depth research, we craft targeted campaigns that reach genuine customers injured in car accidents, optimizing for maximum conversion.",
    },
    {
        title: "Advanced Lead Verification",
        description:
            "Utilizing a cutting-edge verification system, we sift out inaccuracies, prevent fraud, and eliminate duplicates, ensuring only the highest-quality leads are nurtured and optimized for increased conversion rates. We send high-quality leads to your reliable intake center, ensuring you receive leads that are ready to be signed up.",
    },
    {
        title: "Performance Feedback Loop",
        description:
            "We actively seek feedback on lead effectiveness through regular performance reports, allowing us to refine our strategies and continuously enhance lead quality to connect you with your ideal clientele.",
    },
    {
        title: "KPI-Driven Success",
        description:
            "In collaboration with our partners, we establish clear Key Performance Indicators (KPIs) to measure cost-effectiveness and optimize our campaigns based on these KPIs to continuously increase quality and conversions.",
    },
    {
        title: "Ongoing Optimization",
        description:
            "We cyclically refine steps 2 through 4, aiming for a seamless process that consistently meets our shared KPIs and drives mutual satisfaction and success.",
    },
];

export interface OurApproachItem {
    title: string;
    description: string;
}
const paragraphsStyle =
    "mt-2 font-light lg:text-lg 3xl:text-[26px] 3xl:leading-[2.5rem] text-base lg:leading-8 text-[#351C4F]";
export default function OurApproach({
    title = "Our Approach",
    list = ourApproachList,
}: {
    title?: string;
    list?: OurApproachItem[];
}) {
    return (
        <section className={`${styles["bgStyle"]}`}>
            <div className="lg:py-32 py-16">
                <motion.h2
                    transition={{ duration: 1.5 }}
                    initial={{ opacity: 0, y: 150 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-[#351C4F] font-bold  3xl:text-7xl lg:text-5xl lg:leading-[4rem] text-2xl leading-9 text-center 3xl:max-w-[1415px] 3xl:leading-[5.5rem] lg:max-w-[915px] mx-auto"
                >
                    {title}
                </motion.h2>
                <ul className="lg:mt-16 mt-8 flex flex-wrap justify-center 3xl:gap-20 gap-6">
                    {list.map((el, index) => (
                        <motion.li
                            transition={{ duration: 1.5 }}
                            initial={{ opacity: 0, y: 150 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            key={index}
                            className={styles["stepStyle"]}
                        >
                            <h3>{index + 1}</h3>
                            <h4
                                className={`mt-6   lg:text-lg 3xl:text-[26px] 3xl:leading-[2.5rem] text-base lg:leading-8 text-[#351C4F] font-bold`}
                            >
                                {el.title}
                            </h4>
                            <p className={`${paragraphsStyle}`}>
                                {el.description}
                            </p>
                        </motion.li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
